module.exports = __webpack_public_path__ + "img/rosemount-928-wireless-gas-monitor-1-facing-left.409a352f.png";